import ko from "knockout";
import "knockout-punches";
import myFlowLocator from "flow/utils/myFlowLocator";
import { registerKnockoutBinding } from "flow/knockout/register";

const KEY_ENTER = 13;

registerKnockoutBinding("clickOrEnter", {
    init(
        element: HTMLElement,
        valueAccessor: () => any,
        allBindingsAccessor: KnockoutAllBindingsAccessor,
        viewModel: any,
        bindingContext: KnockoutBindingContext
    ) {
        element.setAttribute("tabindex", "0");
        element.setAttribute("role", "link");

        function debouncedClick(...params: any[]) {
            const myFlow = myFlowLocator.getMyFlow(bindingContext.$root);

            if (myFlow.hasOngoingTasks()) {
                return false;
            }

            return valueAccessor()(...params);
        }

        const newValueAccessor = () => {
            return {
                keydown: (data: any, event: JQuery.Event) => {
                    if (event.which === KEY_ENTER) {
                        return debouncedClick(data, event);
                    }
                    return true;
                },
                click: debouncedClick
            };
        };

        ko.bindingHandlers.event.init(element, newValueAccessor, allBindingsAccessor, viewModel, bindingContext);
    }
});

(ko.punches as any).wrappedCallback.enableForBinding("clickOrEnter");
